let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kAOBH")).then(() => parcelRequire('1HjYz'));